import { useQuery } from "@tanstack/react-query";
import { fetchData } from "./../fetchData";

export const useGetSchoolTeachersList = () => {
    return useQuery({
        queryKey: ["school/teachers"],
        queryFn: () => fetchData(`school/teachers`),

    });
};


export const useGetSchoolCoursesList = () => {
    return useQuery({
        queryKey: ["school/courses"],
        queryFn: () => fetchData(`school/courses`),

    });
};


export const useGetSkillToSchoolCourses = () => {
    return useQuery({
        queryKey: ["courses/skill-to-school"],
        queryFn: () => fetchData(`courses/skill-to-school`),

    });
};

export const useGetSkillFourTeachersCourses = () => {
    return useQuery({
        queryKey: ["courses/skill-for-teachers"],
        queryFn: () => fetchData(`courses/skill-for-teachers`),

    });
};




export const useGetTeacherWithCourses = () => {
    return useQuery({
        queryKey: ["school/teachers-with-courses"],
        queryFn: () => fetchData(`school/teachers-with-courses`),

    });
};

export const useGetReviews = ({ id, page = 1, limit = 3 }) => {
    return useQuery({
        queryKey: ["reviews", id, page, limit],
        queryFn: () =>
            fetchData(`reviews/${id}?page=${page}&limit=${limit}`),
        enabled: !!id, // only run when id exists
    });
};





